import React from "react";
import Constants from "../../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { CouponStatusType } from "../../enums/index";
function PagingTwo(props) {

  const goToPage = (e, page) => {
    props.setSelectedPageIndex(page);
    props.setCoupons(
      props.filter === CouponStatusType.Active() ? true : false,
      page
    );
  };
  
  return (
    props.searchPages.length > 1 && (
      <div className="paging">
        <FontAwesomeIcon
          className={props.selectedPageIndex > 1 ? "" : "not-show"}
          icon={faChevronLeft}
          onClick={(e) => goToPage(e, props.selectedPageIndex - 1)}
        />
        {props.searchPages.map(
          (s, index) =>
            Math.abs(index + 1 - props.selectedPageIndex) <
              Constants.searchPagingLimit && (
              <span
                onClick={(e) => goToPage(e, s)}
                key={index}
                className={s === props.selectedPageIndex ? `active` : ``}
              >
                {s}
              </span>
            )
        )}
        <FontAwesomeIcon
          className={
            props.searchPages.length !== 0 &&
            props.selectedPageIndex !== props.searchPages.length
              ? ""
              : "not-show"
          }
          icon={faChevronRight}
          onClick={(e) => goToPage(e, props.selectedPageIndex + 1)}
        />
      </div>
    )
  );
}
export default PagingTwo;
